// Profile of Alina Tselinina, Swedish. Source of the profile page.
module.exports = {
  headline: 'AI / Software Engineer • Python, R & AWS',
  summary: 'Alina Tselinina är mjukvaruingenjör med bakgrund inom data engineering, tillämpad matematik och maskininlärning och arbetar nu med AI-drivna applikationer och agentiska system. Hon har erfarenhet av att bygga API:er och datapipelines, modernisera applikationer genom molnmigrering och utveckla ML-baserade tjänster. Hennes fokus är att koppla samman LLM:er och AI-agenter med pålitliga mjukvarusystem genom strukturerade arbetsflöden, integrationer, testning och iterativ utvärdering.',
  imageAlt: 'Porträtt av Alina Tselinina',
  personal: {
    languages: 'Engelska, polska',
    programmingLanguages: 'Python, R, SQL, Bash'
  },
  education: [
    {
      period: '2014 - 2017',
      field: 'Studier: finans- och försäkringsmatematik',
      institution: 'Adam Mickiewicz-universitetet, Poznań',
      degree: 'Examen: masterexamen'
    },
    {
      period: '2009 - 2014',
      field: 'Studier: matematik',
      institution: 'Belarusiska statsuniversitetet, Minsk',
      degree: 'Examen: kandidatexamen'
    }
  ],
  skills: [
    {
      title: 'Programmering',
      description: 'Python, R, SQL, Bash'
    },
    {
      title: 'AI och LLM:er',
      description: 'Claude, MCP, AI-agenter, LLM-anpassning, modellträning och utvärdering'
    },
    {
      title: 'Moln och data',
      description: 'AWS (Lambda, EC2, S3, Glue, RDS, Athena, Step Functions), Snowflake'
    },
    {
      title: 'Ramverk och API:er',
      description: 'FastAPI, Flask, Shiny, REST-API:er, Swagger, JSON Schema, Jinja, lxml'
    },
    {
      title: 'Data engineering och DevOps',
      description: 'ETL, Airflow, Docker, Git, Linux, CI/CD'
    },
    {
      title: 'Databaser och orkestrering',
      description: 'PostgreSQL, Camunda'
    },
    {
      title: 'Atlassian-verktyg',
      description: 'Jira, Bitbucket, Confluence'
    }
  ],
  positions: [
    {
      period: 'Sedan mars 2026',
      title: 'AI / Software Engineer, pAIoneer Labs',
      description: [
        'Utveckling av AI-agenter, konfiguration av arbetsflöden och verktygsintegration.',
        'Anpassning av LLM:er samt modellträning och utvärdering.',
        'Utveckling och integration av AI-drivna applikationer.',
        'Kvantdatorer: bidrag till mjukvaruutveckling för kvantapplikationer.'
      ]
    },
    {
      period: 'Sedan maj 2025',
      title: 'Senior Software Developer, Geninvo',
      description: [
        'Apputveckling.',
        'Implementering av enhets- och UI-tester som stöd för applikationskvaliteten.'
      ]
    },
    {
      period: 'november 2022 - februari 2025',
      title: 'Senior Python Developer, T-Systems',
      description: [
        'Underhåll och förbättring av datapipelines och orkestrering av arbetsflöden.',
        'Utveckling av paket för rapportautomatisering.'
      ]
    },
    {
      period: 'juli 2022 - oktober 2022',
      title: 'Data Engineer, S&P Global',
      description: [
        'Utveckling och underhåll av ETL-pipelines.'
      ]
    },
    {
      period: 'mars 2022 - juni 2022',
      title: 'Python Developer, DevBridge',
      description: [
        'Design och utveckling av REST-API:er och backend-tjänster.',
        'Implementering av backendlogik för JSON-bearbetning.'
      ]
    },
    {
      period: 'november 2020 - mars 2022',
      title: 'Senior Software Developer, Roche',
      description: [
        'Design och utveckling av REST-API:er och backend-tjänster (proof of concept).',
        'Utveckling och underhåll av ETL-pipelines.',
        'Modernisering av on-premise-applikationer genom AWS-migrering och omskrivning av R-kod till Python.',
        'XML-validering och omvandling till HTML.',
        'Utveckling av webbapplikationer.'
      ]
    },
    {
      period: 'maj 2020 - november 2020',
      title: 'Data Scientist, PSI Polska, Poznań',
      description: [
        'Design och utveckling av REST-API:er och backend-tjänster med en maskininlärningsmodell i backend.',
        'Utveckling av en kundsegmenteringsmodell.'
      ]
    },
    {
      period: 'januari 2019 - april 2020',
      title: 'Advanced Data Scientist, Analyx, Poznań',
      description: [
        'Webbskrapning och utveckling av datapipelines.',
        'Utveckling av webbapplikationer.',
        'Marketing mix-modellering.',
        'Optimering av arbetsflöden.'
      ]
    },
    {
      period: 'maj 2018 - december 2018',
      title: 'Data Scientist, Poznań',
      description: [
        'Utveckling av en ETL-process.',
        'Underhåll av Bash-skript.',
        'Kundsupport och ad hoc-analyser.'
      ]
    },
    {
      period: 'april 2017 - april 2018',
      title: 'Junior Analyst, Poznań',
      description: [
        'Dataanalys och framtagning av rapporter.',
        'Framtagning av dokumentation och presentationer.'
      ]
    }
  ]
};
